<template>
  <div id="hero" class="hero-wrap style7 hero-bg-13 bg-f">
    <img
      src="../../assets/images/hero/hero-shape-6.png"
      alt="Image"
      class="hero-shape-one"
    />
    <div class="container">
      <div class="row gx-5 align-items-end">
        <div class="col-lg-6">
          <div class="hero-content" data-speed="0.10" data-revert="true">
            <span>Welcome To Clean Teeth</span>
            <h1>Best Guideline For Treatment With Lesar Therapy</h1>
            <p>
              Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus
              hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet
              vel dapibus id dolor sit amet standard dummy text ever since the
              when an unknown printer.
            </p>
            <div class="hero-btn">
              <a href="#appointment" class="btn style2">Book An Appointment</a>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="hero-img-wrap">
            <img src="../../assets/images/hero/hero-img-14.png" alt="Image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>